export const EVM_WALLET_DATA_CACHE_KEY = 'evm/wallet/data';
export const EVM_SERVICE_NAME = 'evmService';
export const CACHE_REFRESH_INTERVAL_MS = 60 * 1000; // 60 seconds
